// extracted by mini-css-extract-plugin
export var container = "_rl-0";
export var dotAnimation = "_rl-2";
export var dotsLoading = "_rl-1";